import { isGlobalFeatureEnabled } from "owa-feature-flags";
import getKeyboardShortcutsMode from "owa-hotkeys/lib/utils/getKeyboardShortcutsMode";
import isKeyboardShortcutsDisabled from "owa-hotkeys/lib/utils/isKeyboardShortcutsDisabled";
import shouldUseMonarchShortcuts from "owa-hotkeys/lib/utils/shouldUseMonarchShortcuts";
import type { TableView } from "owa-mail-list-store";
import { MonarchKeyboardShortcutsMode } from "owa-outlook-service-option-store";
import getJumpToSortInfo from "./getJumpToSortInfo";
import shouldShowJumpTo from "./shouldShowJumpTo";
import isJumpToTextInputSort from "./isJumpToTextInputSort";

export default function shouldAllowTypeToJump(tableView: TableView | undefined): boolean {
    if (!isGlobalFeatureEnabled("tri-ml-type-to-jump")) {
        return false;
    }
    
    const usesWindowsShortcuts = shouldUseMonarchShortcuts() &&
        getKeyboardShortcutsMode() === MonarchKeyboardShortcutsMode.OutlookForWindows;
    if (!usesWindowsShortcuts && !isKeyboardShortcutsDisabled()) {
        return false;
    }
    
    const sortColumn = getJumpToSortInfo(tableView)?.sortColumn;
    return isJumpToTextInputSort(sortColumn) && shouldShowJumpTo(tableView);
}
